import classnames from "classnames";

// Navigation Links
export const getTabClassName = (activeTab, tabName = "") =>
  classnames({
    "d-flex align-items-center nav-link text-start": true,
    active: activeTab === tabName
  });

export const getSearchIconClassName = (isOpen) =>
  classnames({
    "d-flex align-items-center nav-link text-start search-icon": true,
    "active-search": isOpen
  });

export const getPersonIconClassName = (isOpen) =>
  classnames({
    "d-flex align-items-center nav-link text-start person-icon": true,
    "active-account": isOpen
  });

export const getTabFiltersClassName = (isOpen) =>
  classnames({
    "tab-filters-container": true,
    "filters-visible": isOpen
  });

export const getAccountNavigationClassName = (isOpen) =>
  classnames({
    "account-navigation-container": true,
    "account-navigation-visible": isOpen
  });

// Desktop Sidebar Toggle
export const getTogglerClassName = (isOpen) =>
  classnames({
    "align-items-center text-start menu-action-button": true,
    "d-flex justify-content-end": isOpen,
    "d-none": !isOpen
  });

// Template
export const getMainContentContainerClasses = (fullHeight, fullWidth) =>
  classnames({
    "main-content-container": true,
    "h-100": fullHeight,
    "w-100": fullWidth
  });

// Player Header
export const getPlayerClassName = (show) =>
  classnames({
    "d-flex align-items-center player-header py-3": true,
    "hide-player-header": !show
  });

// Stream Player
export const getHeaderClassName = (showHeader) =>
  classnames({
    "d-flex align-items-center player-header py-3": true,
    "hide-player-header": !showHeader
  });

// Network Card
export const getImgDivClassName = () =>
  classnames(
    "network-card",
    "h-100",
    "w-100",
    "d-flex",
    "flex-column",
    "justify-content-center",
    "align-items-center",
    "p-2",
    "network-url"
  );

// Event Card
export const getCardClassName = (isLive, showDefaultBackground) =>
  classnames({
    "event-live": isLive,
    "event-playable": true,
    "event-default-background": showDefaultBackground
  });

export const getIconContainerClassName = (isStatusValid) =>
  classnames({
    "watch-now": true,
    "event-on-demand": isStatusValid
  });

export const getCardImageOverlay = (showDefaultBackground) =>
  classnames({
    "default-background": showDefaultBackground
  });
